import React from 'react';
import ReactDOM from 'react-dom';
import { Icon } from 'js/components';
import { setCustomNativeDragPreview } from '@atlaskit/pragmatic-drag-and-drop/element/set-custom-native-drag-preview';
import { preserveOffsetOnSource } from '@atlaskit/pragmatic-drag-and-drop/element/preserve-offset-on-source';

export function mountOrgTreeDragPreview(args, preview) {
  const { nativeSetDragImage, source, location } = args;
  if (!nativeSetDragImage) {
    return;
  }

  setCustomNativeDragPreview({
    nativeSetDragImage,
    getOffset: preserveOffsetOnSource({
      element: source.element,
      input: location.current.input,
    }),
    render: ({ container }) => {
      ReactDOM.render(
        <OrgTreeDragPreview kind={preview.kind} name={preview.name} />,
        container
      );
      return () => {
        ReactDOM.unmountComponentAtNode(container);
      };
    },
  });
}

function OrgTreeDragPreview({ kind, name }) {
  let icon;
  if (kind === 'organization') {
    icon = <Icon className="row-icon org-icon" icon="sitemap" />;
  } else if (kind === 'group') {
    icon = (
      <Icon
        className="row-icon folder-icon"
        icon="user-friends"
        mask="folder"
        transform="shrink-9 down-1"
      />
    );
  } else {
    icon = <Icon className="row-icon team-icon" icon="users" />;
  }

  return (
    <div className="org-tree-drag-preview">
      <span className="org-tree-drag-preview__icon-wrap">{icon}</span>
      <span className="org-tree-drag-preview__name">{name}</span>
    </div>
  );
}
